import { __assign, __generator, __spreadArray } from "tslib";
import { all, takeEvery, select, put, call } from 'redux-saga/effects';
import i18next from 'i18next';
import { request } from '../../xhr';
import { awardBadge, awardBadgeFail, awardBadgeSuccess, fetchAvailableBadges, fetchAvailableBadgesSuccess, fetchBadgeGiverStreamNext, awardingBadge, } from './actionCreators';
import { getIsMobile } from '../../publicSession/selectors';
import { removeModalsOfType } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
import { NotificationType } from '../../Notifications/redux/types';
import { setWatchingState } from '../../WatchButton/redux/actionCreators';
import { getDeviationNotificationQueue } from '../../DeviationPage/redux/helpers';
import { getCommentNotificationQueue } from '../../Comment/utils';
import { withOffset, selectors as streamSelectors } from '../../Stream';
import { DeviationResourceType } from '../../types/deviation';
import { ResourceType } from '../../types/resource';
import { getIsAwarding } from './selectors';
function getFakeStreamData() {
    if (process.env.NODE_ENV !== 'production') {
        var users = require('@wix/da-sample-data').users; // eslint-disable-line global-require
        var Chance = require('chance').Chance; // eslint-disable-line global-require
        var chance_1 = new Chance();
        return {
            hasMore: false,
            nextOffset: null,
            results: chance_1.pickset(users, 20).map(function (user) { return (__assign(__assign({}, user), { isWatching: chance_1.bool(), profile: { tagline: chance_1.bool() ? chance_1.sentence() : '' } })); }),
        };
    }
    return false;
}
function handleAwardBadge(action) {
    var _a, badgeType, recipient, isAwarding, data, result, newBalance, allBadges;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, badgeType = _a.badgeType, recipient = _a.recipient;
                return [4 /*yield*/, select(getIsAwarding)];
            case 1:
                isAwarding = _c.sent();
                if (isAwarding) {
                    return [2 /*return*/];
                }
                data = {
                    badgetype: badgeType,
                    typeid: recipient.typeId,
                    itemid: recipient.itemId,
                    userid: recipient.user.userId,
                };
                return [4 /*yield*/, put(awardingBadge())];
            case 2:
                _c.sent();
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'corebadge/award',
                        data: data,
                    })];
            case 3:
                result = _c.sent();
                if (!(result && result.badge)) return [3 /*break*/, 6];
                // Close the modal first
                return [4 /*yield*/, put(removeModalsOfType(ModalType.AWARD_BADGE))];
            case 4:
                // Close the modal first
                _c.sent();
                newBalance = result.balance;
                allBadges = (_b = result.allBadges) !== null && _b !== void 0 ? _b : [];
                return [4 /*yield*/, put(awardBadgeSuccess(result.badge, recipient, newBalance, allBadges))];
            case 5:
                _c.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(awardBadgeFail(badgeType, recipient, result.errorDescription || i18next.t('common.somethingWentWrong')))];
            case 7:
                _c.sent();
                _c.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
function handleAwardBadgeSuccess(action) {
    var _a, badge, recipient, notification, isMobile;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, badge = _a.badge, recipient = _a.recipient;
                notification = {
                    badge: badge,
                    recipient: recipient,
                };
                return [4 /*yield*/, select(getIsMobile)];
            case 1:
                isMobile = _b.sent();
                return [4 /*yield*/, put(addNotificationToQueue(getBadgeNotificationQueue(recipient, isMobile), NotificationType.Badge, notification))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
/** returns proper queuename based on what's being awarded a badge */
function getBadgeNotificationQueue(recipient, isMobile) {
    if (isMobile) {
        return 'default';
    }
    if (DeviationResourceType[recipient.typeId]) {
        // It's not especially pretty, but the queue only needs type and id
        return getDeviationNotificationQueue({
            typeId: recipient.typeId,
            deviationId: recipient.itemId,
        });
    }
    if (recipient.typeId === ResourceType.COMMENT) {
        return getCommentNotificationQueue({
            commentId: recipient.itemId,
        });
    }
    return 'default';
}
function handleFetchAvailableBadges(action) {
    var userId, params, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                userId = action.payload.userId;
                params = {
                    userid: userId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'corebadge/available_badges',
                        params: params,
                    })];
            case 1:
                result = _a.sent();
                if (!result) return [3 /*break*/, 3];
                return [4 /*yield*/, put(fetchAvailableBadgesSuccess(userId, result.results))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
function handleStreamFetch(action) {
    var streamId, streamParams, _a, offset, limit, recipient, params, result, hasMore, nextOffset, results;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                streamId = action.payload.streamId;
                return [4 /*yield*/, select(streamSelectors.getStreamParams, streamId)];
            case 1:
                streamParams = _b.sent();
                return [4 /*yield*/, select(function (state) { return ({
                        offset: withOffset.selectors.getNextOffset(state, streamId),
                        limit: streamSelectors.getItemsPerFetch(state, streamId),
                    }); })];
            case 2:
                _a = _b.sent(), offset = _a.offset, limit = _a.limit;
                recipient = streamParams.recipient;
                params = {
                    badgetype: streamParams.type,
                    typeid: recipient.typeId,
                    itemid: recipient.itemId,
                    userid: recipient.user.userId,
                    offset: offset,
                    limit: limit,
                };
                return [4 /*yield*/, call(request, { method: 'get', url: 'corebadge/givers', params: params }, getFakeStreamData)];
            case 3:
                result = _b.sent();
                if (!result) return [3 /*break*/, 5];
                hasMore = result.hasMore, nextOffset = result.nextOffset, results = result.results;
                return [4 /*yield*/, all(__spreadArray(__spreadArray([], results.map(function (user) { var _a; return put(setWatchingState(user.username, (_a = user.isWatching) !== null && _a !== void 0 ? _a : false)); }), true), [
                        put(withOffset.actions.fetchSuccess({
                            streamId: streamId,
                            hasMore: !!hasMore,
                            nextOffset: nextOffset !== null && nextOffset !== void 0 ? nextOffset : undefined,
                            items: results,
                        })),
                    ], false))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(awardBadge, handleAwardBadge),
                    takeEvery(awardBadgeSuccess, handleAwardBadgeSuccess),
                    takeEvery(fetchBadgeGiverStreamNext, handleStreamFetch),
                    takeEvery(fetchAvailableBadges, handleFetchAvailableBadges),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map